import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { SignatureFieldWUT } from '../../../ui/signature-field/signature-field-wut';
export function SignatureWUT(props) {
  const {
    fieldType = FIELD_TYPES.SIGNATURE
  } = props;
  return /*#__PURE__*/React.createElement(SignatureFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
}
//# sourceMappingURL=signature-wut.js.map